import { createContext } from 'react';

import { History } from 'history';
import { useSafeContext } from './use-safe-context';

export const HistoryContext = createContext<History | undefined>(
  undefined
);

export function useHistory(): History {
  return useSafeContext(HistoryContext, 'history');
}
